// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__11T1f","description":"PatientConsentPreview_description__34UH8"};